import { CrmBaseTransformer } from '@touch4it/ng-swp/endpoint';

export class EndpointResponseTransformer<T extends { id: unknown }> extends CrmBaseTransformer<T & { _id: string }> {
  override transform(data: T): T & { _id: string } {
    return { ...data, _id: String(data.id) };
  }
}
